import { mapObjIndexed } from 'ramda';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { createAsyncValidation, createValidation } from '../validationFunctions';

export default (formName, fieldsObject) =>
	mapObjIndexed((item = {}, key) => {
		const {
			required = false,
			validations = [],
			asyncValidations = [],
			requiredMessage,
			dependentFields = [],
		} = item;

		return {
			deepPath: key,
			fieldName: key,
			descriptor: {
				name: getLabelMessage(`${formName}:${key}`),
				required,
				requiredMessage,
				validations: validations.map(createValidation),
				asyncValidations: asyncValidations.map(createAsyncValidation),
			},
			dependentFields,
		};
	}, fieldsObject);
